const formatConfig = {
    decimalSeparator:",",
    decimalScale:2,
    fixedDecimalScale:true,
    thousandSeparator: ".",
}

export default formatConfig
